import { createSlice } from "@reduxjs/toolkit";

export const themeSlice = createSlice({
  name: "theme",
  initialState: {
    value: localStorage.getItem("theme") || "blue",
  },
  reducers: {
    changeTheme: (state, action) => {
      state.value = action.payload;
      localStorage.setItem("theme", action.payload);
    },
  },
});

export const selectTheme = (state) => state.theme.value;
export const { changeTheme } = themeSlice.actions;
export default themeSlice.reducer;
